<div class="professional-card-new" [dir]="direction.isRTL() ? 'rtl' : 'ltr'">

    <div class="card-header">
        <a class="avatar-link" type="button" appClick [routerLink]="routerLinkString()">
            <div class="avatar">
                <img *ngIf="hasLogo" [src]="image">
                <span *ngIf="!hasLogo" class="avatar-initials">{{ initials }}</span>
            </div>
        </a>

        <div class="header-info">
            <a class="name" type="button" appClick [routerLink]="routerLinkString()">{{ professional?.name }}</a>
            <a class="specialization" type="button" appClick [routerLink]="routerLinkString()">
                {{ translateHelper.localize(professional.profession?.title) }}
            </a>
            <div class="company-name" *ngIf="translateHelper.localize(professional.profession?.companyName)">
                {{ translateHelper.localize(professional.profession?.companyName) }}
            </div>
        </div>

        <div class="badges" *ngIf="professional?.badges?.length">
            <span *ngIf="professional?.badges?.includes('new')" class="badge new">{{'new'|translate}}</span>
            <span *ngIf="professional?.badges?.includes('hot')" class="badge hot">{{'hot'|translate}}</span>
        </div>
    </div>

    <div class="card-body">
        <div class="rating-row" *ngIf="professional.profession?.reviewCount">
            <app-rating [value]="professional.profession?.averageRating"></app-rating>
            <span class="rating-count">({{ professional.profession?.reviewCount }})</span>
        </div>

        <div class="info-row" *ngIf="locationLabel">
            <mat-icon>location_on</mat-icon>
            <span>{{ locationLabel }}</span>
        </div>

        <div class="info-row" *ngIf="professional.profession?.yearsOfExperience">
            <mat-icon>work</mat-icon>
            <span>{{ "years_of_experience_value" | translate: { years: professional.profession.yearsOfExperience } }}</span>
        </div>

        <div class="info-row" *ngIf="professional.profession?.hourlyRate">
            <mat-icon>payments</mat-icon>
            <span>{{ professional.profession.hourlyRate | currencyConvert: currencyRate.getBaseCurrency() }}{{ "per_hour_suffix" | translate }}</span>
        </div>

        <div class="caption" *ngIf="translateHelper.localize(professional.promotionalCaption)">{{ translateHelper.localize(professional.promotionalCaption) }}</div>
        <p class="description">{{ translateHelper.localize(professional.profession?.description) }}</p>
    </div>

    <div class="card-footer">

        <button class="btn btn-primary" type="button" appClick [routerLink]="routerLinkString()">
            <div class="label">{{"view_profile"|translate}}</div>
        </button>

        <a *ngIf="contactPhone; else contactProfile" eventCollector eventName="call_phone" category="catalog" itemType="professional" [companyId]="professional.companyId" [productId]="professional._id" href="tel:{{contactPhone}}" class="btn btn-secondary" target="_blank">
            <div class="icon"><mat-icon>chat</mat-icon></div>
            <div class="label">{{"contact_now"|translate}}</div>
        </a>
        <ng-template #contactProfile>
            <a class="btn btn-secondary" type="button" appClick [routerLink]="routerLinkString()">
                <div class="icon"><mat-icon>chat</mat-icon></div>
                <div class="label">{{"contact_now"|translate}}</div>
            </a>
        </ng-template>

    </div>
</div>
